export const TabUser = {
  CLIENT: 'clients',
  FIELDS: 'field'
};
export const headerTabUser = [
  { label: 'Clients Access', param: TabUser.CLIENT, value: 0 },
  { label: 'Fields Access', param: TabUser.FIELDS, value: 1 }
];

export const HEADER_USER_PAGE = [
  { label: 'User Name', sort: 'name', width: 140 },
  { label: 'User Email', sort: 'email' },
  { label: 'Mobile', sort: 'phone', width: 140 },
  { label: 'Role', sort: 'role' },
  { label: 'Allowed Client Access' },
  { label: 'View Access' },
  { label: 'Edit Access' },
  { label: 'Actions', width: 120 }
];

export const HEADER_USER_PAGE_FIELD = [
  { label: 'User Name', sort: 'name' },
  { label: 'User Email', sort: 'email' },
  { label: 'Role', sort: 'role' },
  { label: 'Actions', width: 200 }
];

export const OptionAllowedClientAccess = [
  {
    label: '1',
    value: '1'
  },
  {
    label: '2',
    value: '2'
  },
  {
    label: '3',
    value: '3'
  },
  {
    label: '4',
    value: '4'
  },
  {
    label: '5',
    value: '6'
  }
];
export const Role = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  VIEWER: 'VIEWER',
  EDITOR: 'EDITOR',
  USER: 'USER'
};
export const CredentialsOption = [
  {
    label: 'Super Admin',
    value: Role.SUPER_ADMIN
  },
  {
    label: 'Admin',
    value: Role.ADMIN
  },
  {
    label: 'Manager',
    value: Role.MANAGER
  },
  {
    label: 'Viewer',
    value: Role.VIEWER
  },
  {
    label: 'Editor',
    value: Role.EDITOR
  },
  {
    label: 'App User',
    value: Role.USER
  }
];
export const ViewRestrictionsOption = [
  {
    label: 'Activities',
    value: 'activities'
  },
  {
    label: 'Issues',
    value: 'issues'
  },
  {
    label: 'Reports',
    value: 'reports'
  },
  {
    label: 'Documentation',
    value: 'documentation'
  },
  {
    label: 'Validation',
    value: 'validation'
  },
  {
    label: 'Maintenance',
    value: 'maintenance'
  }
];

export const restrictions = {
  activities: 'ACTIVITIES',
  issues: 'ISSUES',
  validation: 'VALIDATION',
  documentation: 'DOCUMENTATION',
  reports: 'REPORTS',
  maintenance: 'MAINTENANCE'
};

export type User = {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
  role: string;
  lockedAt: string;
  accessibleClients?: {
    id: number;
    clientName: string;
  }[];
  viewAccess?: string[];
  editAccess?: string[];
  photo: { id: number; url: string };
  address: string;
};

export type FormCreateUser = {
  name: string;
  email: string;
  phone?: string;
  role: string;
  clientIds?: string[];
  viewAccess?: string[];
  editAccess?: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  file?: any;
  photoId?: number;
  url?: string;
};
